import React from 'react'
import Typography from 'material-ui/Typography'
import Paper from 'material-ui/Paper'
import Grid from 'material-ui/Grid'
import Button from 'material-ui/Button'
import TextField from 'material-ui/TextField';
import {withStyles} from 'material-ui/styles'
import styles from './styles'
import {validateFormData} from '../../../common/formtool'

class FileUploadSettings extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: {},
      errors: {},
      fileUploadSettings: {
        allowedCometExtensions: [],
        allowedLantekExtensions: [],
        maxFileSize: 0,
        maxAttachmentFileSize: 0,
        allowedAttachmentExtensions: [],
      },
      isUpdateSettingBtnDisabled: true
    }
    this.onChange = this.onChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  onChange(e) {
    let fileUploadSettings = {...this.state.fileUploadSettings}
    fileUploadSettings[e.target.name] = e.target.value
    let errors = {...this.state.errors}
    errors = {
      ...errors,
      [e.target.name]: false
    }
    this.setState({fileUploadSettings: fileUploadSettings, errors})
    let {isUpdateSettingBtnDisabled} = this.state
    if (isUpdateSettingBtnDisabled) {
      this.setState({isUpdateSettingBtnDisabled: false})
    }
  }

  handleSubmit() {
    let fileUploadSettings = {...this.state.fileUploadSettings}

    let validationData = {
      allowedCometExtensions: {
        required: this.props.translate('formfield_error_general_required')
      },
      allowedLantekExtensions: {
        required: this.props.translate('formfield_error_general_required')
      },
      maxFileSize: {
        required: this.props.translate('formfield_error_general_required'),
        range: {
          minValue: 1,
          maxValue: 250,
          message: this.props.translate("security_file_upload_settings_max_file_size_range_description", { min: 1, max: 250 })
        }
      },
      maxAttachmentFileSize: {
        required: this.props.translate('formfield_error_general_required'),
        range: {
          minValue: 1,
          maxValue: 250,
          message: this.props.translate("security_file_upload_settings_max_file_size_range_description", { min: 1, max: 250 })
        }
      },
      allowedAttachmentExtensions: {
        required: this.props.translate('formfield_error_general_required')
      }
    }

    let errors = validateFormData(this.state.fileUploadSettings, validationData);
    const missingFieldName = Object.keys(errors)[0]
    if (missingFieldName) {
      const textField = document.getElementsByName(missingFieldName)[0]
      textField && textField.focus()
    }

    if (Object.keys(errors).length) {
      this.setState({errors: errors})
    } else {
      let self = this;

      const settings = {
        allowedCometExtensions: Array.isArray(fileUploadSettings.allowedCometExtensions)
          ? fileUploadSettings.allowedCometExtensions.join(',')
          : fileUploadSettings.allowedCometExtensions,
        allowedLantekExtensions: Array.isArray(fileUploadSettings.allowedLantekExtensions)
          ? fileUploadSettings.allowedLantekExtensions.join(',')
          : fileUploadSettings.allowedLantekExtensions,
        maxFileSize: fileUploadSettings.maxFileSize,
        maxAttachmentFileSize: fileUploadSettings.maxAttachmentFileSize,
        allowedAttachmentExtensions: Array.isArray(fileUploadSettings.allowedAttachmentExtensions)
          ? fileUploadSettings.allowedAttachmentExtensions.join(',')
          : fileUploadSettings.allowedAttachmentExtensions
      }

      this.props.update(settings).then((_) => {
        self.setState({
          error: {},
          isUpdateSettingBtnDisabled: true
        })

        this.props.getAppSetting();
      }).catch((_) => {
        // For debugging, console.log err

        // toast.error(this.props.translate('error_saving_settings'));
      })
      if (!this.state.isUpdateSettingBtnDisabled) {
        window.scrollTo(0, 0);
      }
    }
  }

  getUpdateError(error) {
    // No custom errors
  }

  render() {
    const {
      classes,
      translate,
      impersonating
    } = this.props

    const {
      fileUploadSettings,
      error,
      errors,
      isUpdateSettingBtnDisabled
    } = this.state

    return (
      <Paper className={classes.paper}>
        <Grid container direction="row" justify="flex-start"
              alignItems="center">
          <Grid item xs={9}>
            <Typography type="title" gutterBottom>
              {translate("security_file_upload_settings_tab")}
            </Typography>
          </Grid>
        </Grid>
        {error && this.getUpdateError(error)}
        <TextField
          required
          error={!!errors.allowedCometExtensions}
          name="allowedCometExtensions"
          label={translate("security_file_upload_settings_allowed_comet_extensions")}
          margin="normal"
          fullWidth
          value={fileUploadSettings.allowedCometExtensions}
          onChange={this.onChange}
          helperText={errors.allowedCometExtensions ? errors.allowedCometExtensions : translate("security_file_upload_settings_allowed_comet_extensions_help")}
          disabled={impersonating}
        />
        <TextField
          required
          error={!!errors.allowedLantekExtensions}
          name="allowedLantekExtensions"
          label={translate("security_file_upload_settings_allowed_lantek_extensions")}
          margin="normal"
          fullWidth
          value={fileUploadSettings.allowedLantekExtensions}
          onChange={this.onChange}
          helperText={errors.allowedLantekExtensions ? errors.allowedLantekExtensions : translate("security_file_upload_settings_allowed_lantek_extensions_help")}
          disabled={impersonating}
        />
        <TextField
          required
          error={!!errors.maxFileSize}
          name="maxFileSize"
          label={translate("security_file_upload_settings_max_file_size")}
          margin="normal"
          fullWidth
          value={fileUploadSettings.maxFileSize ? fileUploadSettings.maxFileSize : ''}
          onChange={this.onChange}
          helperText={errors.maxFileSize ? errors.maxFileSize : translate("security_file_upload_settings_max_file_size_help")}
          disabled={impersonating}
        />
        <TextField
          required
          error={!!errors.allowedAttachmentExtensions}
          name="allowedAttachmentExtensions"
          label={translate("security_file_upload_settings_allowed_attachment_extensions")}
          margin="normal"
          fullWidth
          value={fileUploadSettings.allowedAttachmentExtensions}
          onChange={this.onChange}
          helperText={errors.allowedAttachmentExtensions ? errors.allowedAttachmentExtensions : translate("security_file_upload_settings_allowed_attachment_extensions_help")}
          disabled={impersonating}
        />
        <TextField
          required
          error={!!errors.maxAttachmentFileSize}
          name="maxAttachmentFileSize"
          label={translate("security_file_upload_settings_max_file_size")}
          margin="normal"
          fullWidth
          value={fileUploadSettings.maxAttachmentFileSize ? fileUploadSettings.maxAttachmentFileSize : ''}
          onChange={this.onChange}
          helperText={errors.maxAttachmentFileSize ? errors.maxAttachmentFileSize : translate("security_file_upload_settings_max_attachment_file_size_help")}
          disabled={impersonating}
        />
        <Button raised
                fullWidth
                color="primary"
                className={classes.update}
                type="submit"
                onClick={this.handleSubmit}
                disabled={isUpdateSettingBtnDisabled || impersonating}
        >
          {translate("profile_update_settings")}
        </Button>
      </Paper>
    )
  }

  componentDidMount() {
    if (this.props.fileUploadSettings) {
      let fileUploadSettings = {...this.props.fileUploadSettings}
      this.setState({
        fileUploadSettings
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.fileUploadSettings && nextProps.fileUploadSettings.id !== this.state.fileUploadSettings.id) {
      let fileUploadSettings = {...nextProps.fileUploadSettings}
      this.setState({
        fileUploadSettings
      })
    }
  }
}

export default withStyles(styles)(FileUploadSettings)



// WEBPACK FOOTER //
// ./src/components/security/fileuploadsettings/index.js